import React from "react";
import { Modal } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import { ModalWrapper } from "./styled";

const CustomizeModal = ({ open, setOpen, children }) => {
  return (
    <Modal
      className="black-mask"
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalWrapper>
        <div className="header">
          <CloseOutlinedIcon onClick={() => setOpen(false)} color="primary" />
        </div>
        <div className="content">{children}</div>
      </ModalWrapper>
    </Modal>
  );
};
export default CustomizeModal;
